module.exports = __webpack_public_path__ + "static/media/S-task13_nodeLink.53d318fb.png";